import { WebAppPrivileges } from "./SettingsUsersTable";

export function formatPrivileges(
  privileges: WebAppPrivileges | undefined,
  emptyText = "No Privileges",
): string {
  if (!privileges) {
    return emptyText;
  }

  const enabledPrivileges: string[] = [];

  if (privileges.spotter) {
    enabledPrivileges.push("Spotter");
  }

  if (privileges.drill_down) {
    enabledPrivileges.push("Drill Down");
  }

  if (privileges.search_data) {
    enabledPrivileges.push("Search Data");
  }

  return enabledPrivileges.length > 0 ? enabledPrivileges.join(", ") : emptyText;
}
